import React, { FC, CSSProperties, memo } from 'react';
import PitToolTip from '../PitToolTip/PitToolTip';
import { clickProps } from '../../PitBimwinApp';
import { BtnProps } from '../../useBtnOpt';
import styles from '../../styles/app.module.scss';
interface PitToolbarMenuProps {
  toolbarMenuList: BtnProps[][] | undefined;
  btnClickCallBack(itemData: BtnProps, index: number, type?: clickProps): void;
  style?: CSSProperties;
}
const PitToolbarMenu: FC<PitToolbarMenuProps> = memo(
  ({ toolbarMenuList, btnClickCallBack, style }) => {
    const btnNode = (toolbarMenuList || []).map(
      (item: BtnProps[], btnIndex: number) => {
        const ItemNode = item.map((itemData: BtnProps, index: number) => {
          const ItemChild = (itemData.children || []).map(
            (childItem: BtnProps, childIndex: number) => {
              return (
                <div
                  className="pit-button"
                  key={childIndex}
                  onClick={btnClickCallBack.bind(
                    null,
                    itemData,
                    btnIndex,
                    itemData.callback && itemData.callback(itemData)
                  )}
                >
                  <div
                    style={{ display: itemData.type === 'img' ? '' : 'none' }}
                  >
                    <img
                      alt="error"
                      src={childItem.path}
                      className="imgInit img"
                    />
                    <img
                      alt="error"
                      src={childItem['hoverPath']}
                      className="imgInit imgHover"
                    />
                  </div>
                  <span
                    style={{ display: childItem.type === 'icon' ? '' : 'none' }}
                    className={childItem.class}
                  />
                  <p
                    style={{ display: childItem.type === 'text' ? '' : 'none' }}
                    className={childItem.class}
                  />
                </div>
              );
            }
          );
          return (
            <div key={index}>
              <PitToolTip context={itemData.title}>
                <div
                  className={`pit-button ${
                    itemData.visible ? 'pit-checked' : ''
                  }`}
                  onClick={btnClickCallBack.bind(
                    null,
                    itemData,
                    btnIndex,
                    itemData.callback && itemData.callback(itemData)
                  )}
                >
                  <div
                    style={{ display: itemData.type === 'img' ? '' : 'none' }}
                  >
                    <img
                      alt="error"
                      src={itemData['imgPath']}
                      className="imgInit img"
                    />
                    <img
                      src={itemData['imgHoverPath']}
                      className="imgInit imgHover"
                      alt="error"
                    />
                  </div>
                  <span
                    style={{ display: itemData.type === 'icon' ? '' : 'none' }}
                    className={itemData.class}
                  />
                  <p
                    style={{ display: itemData.type === 'text' ? '' : 'none' }}
                    className="iconfontInit"
                  >
                    {itemData.text}
                  </p>

                  {/* <!-- 如果有子菜单则显示 --> */}
                  <div
                    className="pit-toolbar-button"
                    style={{ display: itemData.children ? '' : 'none' }}
                  />
                  <div
                    className={`pit-sub-toolbar ${styles['pit-sub-toolbar']} computer`}
                    style={{ display: itemData.children ? '' : 'none' }}
                  >
                    {ItemChild}
                  </div>
                </div>
              </PitToolTip>
            </div>
          );
        });
        return (
          <div className="pit-toolbar-bottom-item" key={btnIndex}>
            {ItemNode}
          </div>
        );
      }
    );
    return (
      <div style={{ ...style }} className="pit-toolbar pit-toolbar-bottom">
        {btnNode}
      </div>
    );
  }
);
export default PitToolbarMenu;
